<template>
  <div class="dt-breadcrumb">
    <i class="dt-breadcrumb-icon"></i>
    <template v-for="(item, index) in currentPath">
      <span>
        <a v-if="item.isLink" @click="gotoNextPage(item, index)">{{
          item.title
        }}</a>
        <span  class="dt-breadcrumb-item-link" v-else> {{ item.title }} </span>
        <span class="dt-breadcrumb-item-separator">></span>
      </span>
    </template>
  </div>
</template>

<script>
export default {
  name: "dt-breadcrumb",
  props: {
    currentPath: Array,
  },
  data() {
    return {
      levelList: null,
    };
  },
  methods: {
    gotoNextPage(item, index) {
      //移除非最后一个节点后面的数据
      if (index != this.currentPath.length - 1) {
        let newCurrentPath = this.currentPath;
        let delIndex = index + 1;
        let delNum = this.currentPath.length - delIndex;
        newCurrentPath.splice(delIndex, delNum);
        this.$store.dispatch("menu/setCurrentPath", newCurrentPath);
      }
      if (item.query != undefined) {
        if (Object.keys(item.query).length != 0) {
          let queryStr = "";
          let splitStr = "";
          Object.keys(item.query).forEach((qitem, index) => {
            if (index == 0) {
              splitStr = "?";
            } else {
              splitStr = "&";
            }
            queryStr += splitStr + qitem + "=" + item.query[qitem];
          });

          if (queryStr != "") {
            item.path = item.path + queryStr;
          }
        }
      }
      this.$util.routerGo(item.path, item.title, item.query);
    },
  },
};
</script>
<style  lang="scss">
.dt-breadcrumb-icon {
  display: block;
  float: left;
  margin-right: 20px;
  margin-top: 18px;
  width: 14px;
  height: 14px;
  vertical-align: middle;
  background: url(../../../assets/main/icon_list.png);
}
  /*.dt-breadcrumb-item-link{*/
    /*color: #009bff !important;*/
  /*}*/
</style>
